'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sort = sort;

var _constants = require('../constants');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function sort(listIds, establishments) {
  var _sortValue;

  var sorter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.ORDERING.ORDER_NONE;

  var sortValue = (_sortValue = {}, _defineProperty(_sortValue, _constants.ORDERING.ORDER_BY_RATING, function (a, b) {
    return establishments[b].combinedRating - establishments[a].combinedRating || establishments[b].id - establishments[a].id;
  }), _defineProperty(_sortValue, _constants.ORDERING.ORDER_BY_PRICE_ASC, function (a, b) {
    return establishments[a].minDayPrice - establishments[b].minDayPrice || establishments[b].id - establishments[a].id;
  }), _defineProperty(_sortValue, _constants.ORDERING.ORDER_BY_PRICE_DESC, function (a, b) {
    return establishments[b].minDayPrice - establishments[a].minDayPrice || establishments[b].id - establishments[a].id;
  }), _defineProperty(_sortValue, _constants.ORDERING.ORDER_BY_HOT_DEALS, function (a, b) {
    return establishments[b].discount - establishments[a].discount || establishments[b].id - establishments[a].id;
  }), _defineProperty(_sortValue, _constants.ORDERING.ORDER_NONE, function (a, b) {
    return establishments[b].computedRating - establishments[a].computedRating || establishments[b].id - establishments[a].id;
  }), _sortValue);
  return listIds.sort(sortValue[sorter]);
}